var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeposit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1679 12.002H13.8331C12.8201 12.002 12 12.822 12 13.8352V20.836C12 21.8491 12.8201 22.6692 13.8331 22.6692H14.6662V21.169C14.6662 20.3419 15.3392 19.6688 16.1663 19.6688H17.8334C18.6604 19.6688 19.3335 20.3419 19.3335 21.169V22.6692H20.6665V21.169C20.6665 20.3419 21.3396 19.6688 22.1666 19.6688H23.8337C24.6608 19.6688 25.3338 20.3419 25.3338 21.169V22.6692H26.1539C27.1669 22.6692 27.987 21.8491 27.987 20.836L28 13.8352C28.001 12.822 27.1809 12.002 26.1679 12.002ZM15.5002 15.0023H14.5002C14.2241 15.0023 14.0001 14.7783 14.0001 14.5022C14.0001 14.2262 14.2241 14.0022 14.5002 14.0022H15.5002C15.7762 14.0022 16.0002 14.2262 16.0002 14.5022C16.0002 14.7783 15.7762 15.0023 15.5002 15.0023ZM20.0005 19.3358C18.8974 19.3358 18.0004 18.4387 18.0004 17.3356C18.0004 16.2324 18.8974 15.3353 20.0005 15.3353C21.1036 15.3353 22.0006 16.2324 22.0006 17.3356C22.0006 18.4387 21.1036 19.3358 20.0005 19.3358Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3338 23.666C24.3338 26.0523 22.3877 27.9995 20.0005 27.9995C17.6134 27.9995 15.6672 26.0523 15.6672 23.666H18.3674C18.5204 24.4261 19.1935 24.9992 20.0005 24.9992C20.8076 24.9992 21.4806 24.4261 21.6336 23.666H24.3338Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 21.1661V22.6662H15.6663V21.1661C15.6663 20.893 15.8933 20.666 16.1663 20.666H17.8334C18.1074 20.666 18.3334 20.892 18.3334 21.1661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3338 21.1661V22.6662H21.6666V21.1661C21.6666 20.893 21.8936 20.666 22.1667 20.666H23.8338C24.1078 20.666 24.3338 20.892 24.3338 21.1661Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeposit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deposit.84d9f55ed9aee4bd4263f8037b04a548.svg";